import { useEffect } from "react";

const DOMAIN = "https://www.speedyresurfacing.com.au";

// Lightweight per-page SEO: title, description, canonical, OG tags, optional JSON-LD.
export default function Seo({ title, description, path = "/", jsonLd = null }) {
  const json = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    document.title = title;
    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", DOMAIN + path);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", DOMAIN + path);

    let script = document.getElementById("page-jsonld");
    if (json) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = json;
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, json]);
  return null;
}
